import { render, staticRenderFns } from "./playerList_itemPanel.vue?vue&type=template&id=8b85a542&scoped=true"
import script from "./playerList_itemPanel.vue?vue&type=script&lang=js"
export * from "./playerList_itemPanel.vue?vue&type=script&lang=js"
import style0 from "./playerList_itemPanel.vue?vue&type=style&index=0&id=8b85a542&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b85a542",
  null
  
)

export default component.exports